import datepicker from "js-datepicker";
// import { tns } from "tiny-slider/src/tiny-slider";
import LazyLoad from "vanilla-lazyload";
function ajax(params) {
  params.search = jQuery("#search").val();
  params.categorie = jQuery("#term").val();
  const archive_container = jQuery(".archive_posts");
  jQuery.ajax({
    url: window.origin + "/wp/wp-admin/admin-ajax.php",
    data: params,
    type: "POST",
    beforeSend: function () {
      archive_container.html("");
      jQuery(".loader").show();
    },
    success: function (data) {
      jQuery(".loader").hide();
      archive_container.html(data);
      const lazyLoad = new LazyLoad();
    },
  });
  return false;
}

export function ajaxArticles() {
  let page = 1;
  const params = {
    action: "ajax_articles",
    categorie: "",
    search: "",
    post_type: jQuery(".post_type").val(),
    page: page,
    date_debut: "",
    date_fin: "",
    type: [],
  };

  jQuery(document).on("click", "#search-post", function (e) {
    e.preventDefault();
    // get current page
    params["page"] = 1;
    ajax(params);
  });
  jQuery(document).on(
    "click",
    ".pagination span, .pagination span.next, .pagination span.prev",
    function (e) {
      // get data-page attribute
      page = jQuery(this).data("page");
      params["page"] = page;
      ajax(params);
      // go up smooth to .main
      jQuery("html, body").animate({ scrollTop: 0 }, 800);
    }
  );
}
